<template>
   <div>
       <div>
            <div class="uploadEx">
                <img :src="imgSrcShow"
                    @click="previewImageHandel('示例')" alt class="businessTimePic" />
                <span >示例图片</span>
            </div>
            <div class="upladItem" v-for="(item, index) in list" :key="item.index">
                <nut-cell v-if="item.src">
                    <template v-slot:default>
                        <span class="nut_icon_span_box"  v-if="!item.src.includes('sign')">
                            <nut-icon name="loading"></nut-icon>
                        </span>
                        <span v-else>
                            <img v-if="type == 'photo'" :src="item.src" @click="previewImageHandel('拍摄', item.type, index)" />
                            <video v-if="type == 'video' && isiOS" :poster="item.src" style="width:100%;height:100%;object-fit:fill;"
                            :id="'videoElement' + index" :src="item.src" @click="previewImageHandel('视频', item.type, index)" ></video>
                             <video v-if="type == 'video' && !isiOS"   style="width:100%;height:100%;object-fit:fill;"
                            :id="'videoElement' + index" :src="item.src" @click="previewImageHandel('视频', item.type, index)" ></video>
                            <!-- :style="{ visibility: showVideoDOM ? 'visible' : 'hidden' }"  -->
                            <nut-icon
                                name="close-little"
                                class="iconDelete"
                                @click="uploadDelete(item.type, index)"
                                v-if="!userCheckDetail"
                            ></nut-icon>
                            <!-- <input type="file" >  -->
                        </span>
                        <span class="span">{{ item.title }}</span>
                    </template>
                </nut-cell>
                <div class="uploadCss" v-else>
                    
                    <div id="video" @click="clack(item.type, index)">
                        <img v-if="type == 'photo'" src="../assets/image_message_appear/camera.png" alt />
                        <img v-if="type == 'video'" src="../assets/image_message_appear/videox1.png" alt />
                        <!-- {{ props.listType != 'infoVideos' && !datanoshow }}
                        datanoshow{{ datanoshow }}
                        {{ showLoading }} -->
                        <!-- {{ showctrol }} -->
                        <template v-if="props.listType != 'infoVideos' && !datanoshow && showctrol">

                                <input type="file"
                                    id="loadfile1"
                                    accept="video/*"
                                    capture="camcorder"
                                    class="inyt"
                                    @change="fileChange('video')"
                                    v-if="store.state.isH5 && type == 'video' && ide == 'ik'">
                                <input type="file"
                                    :id="ide"
                                    accept="video/*"
                                    capture="camcorder"
                                    class="inyt"
                                    @change="fileChange('video')"
                                    v-if="store.state.isH5 && type == 'video' && ide != 'ik'">
                                <!-- <input type="file"
                                    id="loadfile"
                                    accept="image/*"
                                    capture="camera"
                                    @change="fileChange"
                                    v-if="store.state.isH5 && type == 'video'"> -->
                                <input type="file" 
                                    id="loadfile"
                                    accept="image/*"
                                    capture="camera"
                                    class="inyt"
                                    @change="fileChange('photo')"
                                    v-if="store.state.isH5 && type == 'photo' && ide == 'ik'">
                                <input type="file" 
                                    :id="ide"
                                    accept="image/*"
                                    capture="camera"
                                    class="inyt"
                                    @change="fileChange('photo')"
                                    v-if="store.state.isH5 && type == 'photo' && ide != 'ik'">
                            <!-- <input type="file"  id="loadfile"
                                accept="video/*"
                                capture='camcorder'
                                @change="fileChange"
                                v-else-if="store.state.isH5"> -->
                        </template>
                        <!-- 快捷上报 -->
                        <template v-if="props.listType == 'infoVideos' && (clickPhotoNum != 0 || isiOS)">
                            <input type="file"
                                id="loadfile1_infoVideo"
                                accept="video/*"
                                capture="camcorder"
                                class="inyt"
                                @change="fileChange('video')"
                                v-if="store.state.isH5 && type == 'video' && ide == 'ik'">
                            <input type="file"
                                :id="ide"
                                accept="video/*"
                                capture="camcorder"
                                class="inyt"
                                @change="fileChange('video')"
                                v-if="store.state.isH5 && type == 'video' && ide != 'ik'">
                        </template>
                    </div>
                    <span class="span redStar">
                        {{ item.title }}
                        <!-- <span v-if="item.type=='businessPhonePic' || item.type == 'businessTimePic'" style="color: red;">*</span> -->
                    </span>
                </div>
            </div>
        </div>
        <nut-overlay v-model:visible="showPopup">
            <div style="display: flex;justify-content: center;align-items: center;height: 100%;">
                <div class="video_popup">
                    <div>温馨提示</div>
                    <div>为避免文件过大，上传失败，建议单个视频时长不超过5分钟~</div>
                    <button @click="createInputFileDOM" ref="createInputDOM">
                        我知道了
                        <!-- <input type="file"
                            id="loadfile1_infoVideo1"
                            accept="video/*"
                            capture="camcorder"
                            @blur="inputBlurPopupHidden"
                            @change="fileChange('video')"
                        /> -->
                    </button>
                </div>
            </div>
        </nut-overlay>
        <nut-overlay :close-on-click-overlay="false" v-model:visible="showLoading" style="display: flex;justify-content: center;align-items: center;">
            <nut-icon size="30px" color="#fff" name="loading"></nut-icon>
        </nut-overlay>
   </div>
</template>
<script>
import { 
    defineComponent, 
    computed,
    onMounted,
} from 'vue'
import {     
    businessTimeAndPhonePic,
    locationPics,
    locationVideo, 
} from '../view_message_appear/config'
import {
    nextTick,
    ref,
} from 'vue'
import { useStore } from 'vuex'
import utils, {
    setMiniImg
} from '../utils/utils'
import { Toast } from '@nutui/nutui'
const listTypeMap = new Map([
    ['infoVideos', locationVideo],
    ['locationVideo', locationVideo],
    ['locationPics', locationPics],
    ['businessPhonePic', businessTimeAndPhonePic],
    ['businessTimePic', businessTimeAndPhonePic],
])
import { Notify } from "@nutui/nutui";
import request from "@/utils/request";
import * as api from "@/utils/api";
const Cos = require("cos-js-sdk-v5");


// 照片回调方法的数据格式
//     val url: String,  连接
//     val lat: Double, 坐标
//     val lng: Double, 坐标
//     val angle: Double,   角度
//     val time: Long 时间戳
export default defineComponent({
    name: 'photoVue',
    props: {
        list: Array, 
        userCheckDetail: Boolean,
        title: String,
        type: String,
        number: [Number, String],
        listType: String,
        latlng: String,
        ide: {
            type: String,
            default: 'ik'
        },
        // ik 是默认值当无id值传进来的时候使用默认值ik
        pageType: [String, Number],
        userLocation: {
            type: Object,
            default: () => {}
        },
        // 是否限制拍摄视频（内部员工）
        isSetLimit: {
            type: [Boolean, String],
            default: false
        }
    },
    setup(props, ctx) {
        onMounted(() => {
            // window.addEventListener('focus', () => {
            //     console.log('window-focus');
            //     showPopup.value = false
            // // })
            // if(props.latlng == ''){
            //     showctrol.value = false;
            //     if(props.pageType == '1'){
            //         Toast.text('请先进行地点位置的戳点～', {
            //             duration: 1000
            //         })
            //     }else{
            //         Toast.text('请先进行地点名称的选择～', {
            //             duration: 1000
            //         })
            //     }
            //     return
            // }
            // showctrol.value = true;
        })
        const videoDuration = ref(null)
        const createInputDOM = ref(null)
        const showLoading = ref(false)
        const datanoshow = ref(false)
        const showctrol = ref(false)
        const showPopup = ref(false)
        const clickPhotoNum = ref(0)
        const showVideoDOM = ref(false)
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        const imgSrcShow = computed(() => {
            return listTypeMap.get(props.listType)
        })
        const store = useStore();
        const cosByScene = new Cos({
            getAuthorization: function(options, callback) {
                request("post", api.getCosCredentialsByScene, {
                    scene: 'info_report',
                    ext_info: {
                        openid: store.state.userOpenId
                    }
                })
                .then(data => {
                    callback({
                        TmpSecretId: data.data.credentials.tmp_secret_id,
                        TmpSecretKey: data.data.credentials.tmp_secret_key,
                        SecurityToken: data.data.credentials.session_token,
                        ExpiredTime: data.data.credentials.expired_time
                    });
                });
            }
        })
        // 查看图片
        const previewImageHandel = (type, title, index) => {
            ctx.emit('previewImg', {type, title, current: index, url: listTypeMap.get(props.listType)})
        }
        // 删除图片
        const uploadDelete = (title, index) => {
            ctx.emit('deletePic', {title, index})
        }
        const  tolookotherwexin = () => {
            console.log(props.userLocation, props.latlng, 'props--latlng');
              // 距离不够50米退回
            const userLat = props.userLocation.latitude - 0;
            const userLng = props.userLocation.longitude - 0;
            const lat = props.latlng.split(',')[0] - 0;
            const lng = props.latlng.split(',')[1] - 0;
            const Distance = Number(utils.getDistance(userLat, userLng, lat, lng))
            console.log(Distance);
            if(Distance > 50){
                if(props.pageType == '1'){
                    Toast.text('您当前的位置距离戳点位置超过50米，请走近拍摄～', {
                        duration: 1000
                    })
                }else{
                    Toast.text('您当前的位置距离店铺位置超过50米，请走近拍摄～', {
                        duration: 1000
                    })
                }
                return
            }
            if(!showctrol.value) {
                showctrol.value = true;
                let replaceid = props.ide;
                if(props.type == 'video' && props.ide == 'ik') {
                    replaceid = 'loadfile1'
                }
                if(props.type == 'photo' && props.ide == 'ik') {
                    replaceid = 'loadfile'
                }
                setTimeout(()=> {
                    let a = document.getElementById(replaceid);
                    a.click();
                },120)
            }
        };
        // 选择到图片或视频
        const fileChange = (re) => {
            datanoshow.value = true;
            showLoading.value = true;
            videoDuration.value = null;
            const nowTime = new Date().getTime()
            let a;
            if (props.ide != 'ik') {
                a = document.getElementById(props.ide);
            } else if(re == 'video') {
                showPopup.value = false
                if(props.listType == 'infoVideos' && clickPhotoNum.value == 1){
                    a = document.getElementById('loadfile1_infoVideo1')
                } else if(props.listType == 'infoVideos' && clickPhotoNum.value > 1){
                    a = document.getElementById('loadfile1_infoVideo')
                } else{
                    a = document.getElementById('loadfile1');
                }
            } else {
                a = document.getElementById('loadfile');
            }
            const url = URL.createObjectURL(a.files[0]);
            const filelement = new Audio(url);
            if(isiOS){
                filelement.muted = true
                filelement.play().then(()=>filelement.pause())
            }
            filelement.addEventListener("loadedmetadata", function () {
                videoDuration.value = String(filelement.duration).split('.')[0] * 1000;
            });
            if(re == 'video'){
                CosPutObjectwx(a.files[0], re, nowTime)
            }else{
                setMiniImg(a.files[0]).then(miniImgFile => {
                    CosUploadFile(miniImgFile, re, nowTime)
                })
            }
        };
        const CosPutObjectwx = (fileItem, re, nowTime) => {
            const time = new Date().getTime();
            console.log(store.state.userOpenId, 'store.state.userOpenId');
            // let a = store.getters.userInfo
        // let img = await fileToBlob(fileItem);
        const key = `easyearn/info_report/${store.state.userOpenId}/poi/evaluating/${new Date().getTime()}.${re == 'video' ? 'mp4' : fileItem.name.split('.').pop()}`;
        cosByScene.putObject(
          {
            Bucket: 'mapugc-user-1251316161' /* 必须 */,
              // Region: 'ap-shanghai' /* 存储桶所在地域，必须字段 */,
            Region: 'ap-beijing' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
            Key: key /* 必须 */,
            StorageClass: "STANDARD",
            Body: fileItem, // 上传文件对象
            onProgress: function() {}
          },
          function(err, datas) {
            console.log(err,'err');
            console.log(datas,'data');
            if (!datas) {
              Notify.warn("上传失败");
              return;
            }/*  */
            if (datas.Location) {
                ctx.emit('photoadd', [{
                    url: datas.Location,
                    lat: store.state.location.split(',')[0],
                    lng: store.state.location.split(',')[1],
                    angle: '',
                    time: time,
                    lastModified: fileItem.lastModified < 0 ? nowTime : fileItem.lastModified,
                    duration: videoDuration.value
                }])
            }
            datanoshow.value = false;
            if(re != 'video'){
                showLoading.value = false
            }
          }
         );
        };
        const CosUploadFile = (fileItem, re, nowTime) => {
            console.log('CosUploadFile');
            const time = new Date().getTime();
            let a = store.getters.userInfo
        // let img = await fileToBlob(fileItem);
        let  type = 'jpg';
        if (fileItem.type && fileItem.type.indexOf('png') > -1) {
                type = 'png';
              }
        const key = `easyearn/info_report/${store.state.userOpenId}/poi/evaluating/${ a || '' }/${new Date().getTime()}.${re == 'video' ? 'mp4' : type}`;
        cosByScene.uploadFile(
          {
            Bucket: 'mapugc-user-1251316161' /* 必须 */,
              // Region: 'ap-shanghai' /* 存储桶所在地域，必须字段 */,
            Region: 'ap-beijing' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
            Key: key /* 必须 */,
            StorageClass: "STANDARD",
            Body: fileItem, // 上传文件对象
            onProgress: function() {}
          },
          function(err, datas) {
            console.log(err,'err');
            console.log(datas,'data');
            if (!datas) {
              Notify.warn("上传失败");
              return;
            }/*  */
            if (datas.Location) {
                ctx.emit('photoadd', [{
                    url: datas.Location,
                    lat: store.state.location.split(',')[0],
                    lng: store.state.location.split(',')[1],
                    angle: '',
                    time: time,
                    lastModified: fileItem.lastModified < 0 ? nowTime : fileItem.lastModified,
                    duration: videoDuration.value
                }])
            }
            datanoshow.value = false;
            if(re != 'video'){
                showLoading.value = false
            }
          }
         );
        };
        // 上传图片
        const clack = (title, index) => {
            console.log(store.state.isH5, 'store.state.isH5', props.pageType, props.type);
            if(props.latlng == ''){
                showctrol.value = false;
                if(props.pageType == '1'){
                    Toast.text('请先进行地点位置的戳点～', {
                        duration: 1000
                    })
                }else{
                    Toast.text('请先进行地点名称的选择～', {
                        duration: 1000
                    })
                }
                return
            }
            if (store.state.isH5) {
                console.log('拍摄开始');
                console.log(datanoshow.value);
                console.log(props.type == 'photo');
                if(datanoshow.value && props.type == 'photo') {
                    console.log('进来了');
                    Toast.text('照片上传中，请稍等', {
                        duration: 3000
                    })
                    return;
                }
                ctx.emit('selectPicType', {title, current: index})
                if(props.listType == 'infoVideos' && props.list[0].src == '' && clickPhotoNum.value == 0 && !isiOS) {
                    showPopup.value = true
                }
                if(isiOS && props.listType == 'infoVideos') clickPhotoNum.value = 1
                clickPhotoNum.value += 1;
                tolookotherwexin();
                return
            }
            if(props.isSetLimit){
                takeBatchPoiVideoFunc()
                return
            }
            // 未选择坐标退回
            
            // 距离不够50米退回
            const userLat = props.userLocation.latitude - 0;
            const userLng = props.userLocation.longitude - 0;
            const lat = props.latlng.split(',')[0] - 0;
            const lng = props.latlng.split(',')[1] - 0;
            const Distance = Number(utils.getDistance(userLat, userLng, lat, lng));
            // 地点新增
            if (props.pageType == '1' && props.type == 'photo') {
                if (Distance > 500) {
                    Toast.text('您当前的位置距离戳点位置超过500米，请走近拍摄～', {
                        duration: 1000
                    })
                    return
                }
            } else {
                if(Distance > 50){
                    if (props.pageType == '1') {
                        Toast.text('您当前的位置距离戳点位置超过50米，请走近拍摄～', {
                            duration: 1000
                        })
                        return
                    } else {
                        Toast.text('您当前的位置距离店铺位置超过50米，请走近拍摄～', {
                            duration: 1000
                        })
                        return
                    }
                }
            }
            ctx.emit('selectPicType', {title, current: index})
            if(props.type == 'video'){
                // const arr = props.list.filter(item => item.src != '');
                // console.log(props.list, arr);
                // if(arr.length > props.number)
                // Toast.text('最多只能上传' + props.number + '个视频～', {
                //     duration: 1000
                // })
                // else 
                window.easyearn.takeBatchPoiVideo();
            }else{
                window.easyearn.takePoiPicture(props.number - (props.list.length - 1));
            }
        }
        // 创建nputDOM
        const createInputFileDOM = () => {
            showPopupHidden()
            setTimeout(() => {
                const input = document.createElement('input');
                input.type = 'file';
                input.id = "loadfile1_infoVideo1";
                input.accept="video/*";
                input.capture="camcorder";
                input.style.display = 'none';
                document.body.appendChild(input);
                input.click();
                input.addEventListener('change', () => {
                    console.log(input.value);
                    // 轮询
                    if (input.value !== '') { // 不需要change事件
                        fileChange('video')
                    } 
                }, { once: true });
            }, 300);
        }
        // 调用客户端方法
        const takeBatchPoiVideoFunc = () => {
            window.easyearn.takeBatchPoiVideo()
        }
        const showPopupHidden = () => {
            showPopup.value = false;
        }
        // 对视频展示第一帧的处理
        const logList = (url, index) => {
            // const video = document.getElementById('videoElement' + index);
            // const canvas = document.createElement('canvas');
            // video.src = url
            // canvas.width = video.clientWidth;
            // canvas.height = video.clientHeight;
            // video.addEventListener('canplay', () => {
            //     video.currentTime = 1;
            //     video.pause()
            // })
            // video.load()
            console.log('loglist', index);
            nextTick(() => {
                const video = document.getElementById('videoElement' + index);
                video.src = url
                // video.addEventListener('loadedmetadata', function() {
                //     console.log('loadedmetadata');
                //     if(!(isiOS && store.state.isH5)){
                //         video.currentTime = 1
                //     }else{
                //         setTimeout(() => {
                //             showLoading.value = false
                //         }, 230);
                //     }
                //     setTimeout(() => {
                //         showVideoDOM.value = true
                //     }, 180);
                // })
                console.log(isiOS, 'isiOS');
                if(isiOS){
                    setTimeout(() => {
                        showLoading.value = false
                    }, 230);
                }else{
                    showVideoDOM.value = true
                    video.addEventListener('loadeddata', function() {
                        console.log(video,'loadeddata');
                        video.currentTime = 1
                        setTimeout(() => {
                            showVideoDOM.value = true
                        }, 180);
                    })
                }
                video.addEventListener('timeupdate', function() {
                    console.log('timeupdate', video.currentTime);
                    if(video.currentTime > 0){
                        showLoading.value = false
                    }
                })
            })
        }
        return {
            previewImageHandel,
            uploadDelete,
            clack,
            logList,
            imgSrcShow,
            showVideoDOM,
            showPopup,
            store,
            fileChange,
            CosPutObjectwx,
            isiOS,
            props,
            showLoading,
            clickPhotoNum,
            showPopupHidden,
            createInputFileDOM,
            createInputDOM,
            datanoshow,
            showctrol
        }
    },
})
</script>
<style lang='scss' scoped>
.inyt {
    position: relative;
    left: 0;
    width: 100%;
    height: 100%;
    top: -80px;
    height: 100%;
    opacity: 0;
}
// #loadfile{
// }
// #loadfile1{
//     position: relative;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     top: -80px;
//     height: 100%;
//     opacity: 0;
// }
.uploadEx {
    display: inline-block;
    width: 80Px;
    height: 106Px;
    vertical-align: top;
    margin-right: 10Px;
    img {
        width: 80Px;
        height: 80Px;
        display: block;
        border-radius: 4px;
    }
    span {
        opacity: 0.5;
        font-weight: 500;
        white-space: nowrap;
        font-size: 12px;
        text-align: center;
        display: block;
        color: #17181A;
        margin-top: 8Px;
        margin-bottom: 12px;
    }
}
.upladItem {
    display: inline-block;
    width: 80Px;
    height: 108Px;
    vertical-align: top;
    margin-right: 10Px;
    margin-bottom: 12px;
    & :deep(.nut-cell) {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        border-radius: 4px;
        overflow: hidden;
        .iconDelete {
            width: 14px;
            height: 14px;
            background: rgba(0, 0, 0, 0.7);
            color: white;
            position: absolute;
            top: 4px;
            right: 4px;
            font-size: 6px;
            border-radius: 50%;
        }
    }
    .nut_icon_span_box{
        width: 80Px;
        height: 80Px;
        display: block;
        text-align: center;
        line-height: 80Px;
    }
    img, video {
        width: 80Px;
        height: 80Px;
        border-radius: 4px;
        display: block;
    }
    .span {
        opacity: 0.5;
        font-weight: 500;
        font-size: 12px;
        white-space: nowrap;
        text-align: center;
        display: block;
        margin-top: 8Px;
        color: #17181A;
    }
    .redStar::after{
        content: '*';
        color: red;
        opacity: 1;
    }
}
.nut-cell{
    display: block;
    color: #000;
    line-height: unset;
    box-shadow: none;
}
.uploadCss {
    width: 80Px;
    height: 80Px;
    display: inline-block;
    vertical-align: top;
    &>div {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        img {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 4px;
        }
    }
    span {
        opacity: 0.5;
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        display: block;
        margin-top: 9px;
    }
}
.videoShow{
    visibility: visible;
    // position: relative;
}
.videoHidden{
    visibility: hidden;
    // position: absolute;
}
.video_popup{
    text-align: center;
    width: 89%;
    overflow: hidden;
    border-radius: 8px;
    margin: 0 auto;
    background-color: #fff;
    div:nth-child(1){
        padding-top: 32px;
        height: 24px;
        opacity: 0.9;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 17px;
        color: #0B0D0C;
        letter-spacing: 0;
        text-align: center;
    }
    div:nth-child(2){
        opacity: 0.5;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        font-size: 16px;
        padding: 16px 24px 32px;
        border-bottom: 1px solid #0000001a;
    }
    button{
        width: 45%;
        border: none;
        background-color: #fff;
        display: block;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 17px;
        color: #3E72FF;
        letter-spacing: 1px;
        text-align: center;
        line-height: 24px;
        margin: 0 auto;
        padding: 16px 0;
    }
    input{
        opacity: 0;
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 11px 30px;
    }
}
</style>
